export default __webpack_public_path__ + "static/dmc-welcome-9c76819fc76f0cc1dc23ce1af08f456f.png";